import { For } from "solid-js";
import { spriteHrefFor } from "../lib/logos";
import { t } from "../lib/i18n";

interface ThinkingAnimationProps {
  /** Model display name, e.g. "Grok 4.3". Used to look up the sprite. */
  modelLabel: string;
}

/**
 * Idle filler while the LLM is generating. Just the model's logo, the model
 * name, and "is thinking" with three bouncing dots. No orbits, no halos,
 * no AI slop. The dots animate via CSS transform only.
 */
export function ThinkingAnimation(props: ThinkingAnimationProps) {
  const href = () => spriteHrefFor(props.modelLabel);
  return (
    <div class="thinking-stage" aria-live="polite">
      <div class="thinking-logo">
        {href() ? (
          <svg viewBox="0 0 64 64" width="96" height="96" aria-hidden="true">
            <use href={href()!} />
          </svg>
        ) : null}
      </div>
      <div class="thinking-label">
        <span class="thinking-model">{props.modelLabel}</span>
        <span class="thinking-verb"> {t("idea.isThinking")}</span>
        <span class="thinking-dots" aria-hidden="true">
          <For each={[0, 1, 2]}>
            {(i) => (
              <span
                class="thinking-dot"
                style={{ "animation-delay": `${i * 0.18}s` }}
              />
            )}
          </For>
        </span>
      </div>
    </div>
  );
}
